import { toKebabCase } from "@eusoft/webapp-core/utils/String";
import { MaterialIcon } from "@eusoft/webapp-ui/components/Icon";
import { formatString, formatText } from "@eusoft/webapp-ui/utils/Format";
import { MarkDown } from "../components/MarkDown";
import  { DeviceType, OrderStatus, OrderType, PaymentCardStatus, PaymentMethod, SalePointType, TransactionType } from "../entities/Commands";
import type { LocalString, ViewNode } from "@eusoft/webapp-ui/types";


export interface IStatusFormat {
    label: LocalString;
    style?: string;
    icon?: ViewNode;    
}

export function formatMarkDown(text: LocalString, ...args: string[]) {

    return <MarkDown linkTarget="_blank">{formatText(text, args) as string}</MarkDown>
}

export function formatCardStatus(value: PaymentCardStatus): IStatusFormat {
    if (value == PaymentCardStatus.Active)
        return {
            label: "active",
            style: "green",
            icon: <MaterialIcon name="check_circle"  />    
        }
    if (value == PaymentCardStatus.Blocked)
        return {
            label: "blocked",
            style: "red",
            icon: <MaterialIcon name="block" />    
        }
    if (value == PaymentCardStatus.NotActive)
        return {
            label: "not-active",
            style: "gray",
            icon: <MaterialIcon name="shopping_cart_off" />  
        }
}


export function formatTransactionType(value: TransactionType): IStatusFormat {
    if (value == TransactionType.Buy)
        return {
            label: "buy",
            icon: <MaterialIcon name="shopping_cart" />
        }
    if (value == TransactionType.Charge)
        return {
            label: "charge",
            icon: <MaterialIcon name="arrow_circle_up" />
        }
    if (value == TransactionType.OrderRefund)
        return {
            label: "order-refund",
            icon: <MaterialIcon name="undo" />
        }
    if (value == TransactionType.CardRefund)
        return {
            label: "card-refund",
            icon: <MaterialIcon name="money" />
        }
    if (value == TransactionType.Transfer)
        return {
            label: "transfer",
            icon: <MaterialIcon name="sync_alt" />
        }
}

export function formatOrderType(value: OrderType) {

    return formatString(toKebabCase(OrderType[value]));
}

export function formatPaymentMethod(value: PaymentMethod) {

    return formatString(toKebabCase(PaymentMethod[value]));
}

export function formatSalePointType(value: SalePointType) {

    return formatString(toKebabCase(SalePointType[value]));
}

export function formatDeviceType(value: DeviceType) {

    return formatString(toKebabCase(DeviceType[value]));
}

export function formatOrderStatus(value: OrderStatus): IStatusFormat {
    if (value == OrderStatus.Created)
        return {
            label: "created",
            style: "gray",
            icon: <MaterialIcon name="flag" />
        }
    if (value == OrderStatus.Paid) 
        return {
            label: "payed",
            style: "green",
            icon: <MaterialIcon name="check_circle" />
        }
    if (value == OrderStatus.WaitForPayment)
        return {
            label: "wait-payment",
            style: "yellow",
            icon: <MaterialIcon name="schedule" />
        }
    if (value == OrderStatus.Changed)
        return {
            label: "changed",
            style: "green",
            icon: <MaterialIcon name="edit" />
        }

    if (value == OrderStatus.Refunded)
        return {
            label: "refunded",
            style: "red",
            icon: <MaterialIcon name="undo" />
        }
}


